<template>
	<div class="main-business-dropdown">
		<m-inline-dropdown :value="activeScale" :options="scaleOptions" position="right" @change="handleChangeScale">
			<template v-slot:title="props">
				<span class="dropdown-menu-text">{{ props.actived.text }}</span>
				<span class="dropdown-angle-icon"></span>
			</template>
		</m-inline-dropdown>

		<m-inline-dropdown :value="activeDate" :options="dateOptions" position="right" @change="handleChangeDate">
			<template v-slot:title="props">
				<span class="dropdown-menu-text">{{ props.actived.text }}</span>
				<span class="dropdown-angle-icon"></span>
			</template>
		</m-inline-dropdown>

		<m-inline-dropdown
			:value="activePeriod"
			:options="comparisonPeriod"
			position="right"
			@change="handleChangePeriod"
		>
			<template v-slot:title="props">
				<span class="dropdown-menu-text">{{ props.actived.text }}</span>
				<span class="dropdown-angle-icon"></span>
			</template>
		</m-inline-dropdown>
	</div>
</template>
<script setup>
import { useMainBusinessMap } from './useMainBusinessMap';

defineProps({
	// 比例还是数值
	activeScale: {
		type: Number,
		default: 1 // 比例还是数值
	},
	activeDate: {
		type: Number,
		required: true
	},
	activePeriod: {
		type: String,
		required: true
	}
});
const emit = defineEmits(['update:activeDate', 'update:activePeriod', 'dateChange', 'periodChange']);
const { scaleOptions, dateOptions, comparisonPeriod } = useMainBusinessMap();
const handleChangeScale = item => {
	console.log(item);
	emit('update:activeScale', item.value);
	emit('scaleChange', item.value);
};
const handleChangeDate = item => {
	console.log(item);
	emit('update:activeDate', item.value);
	emit('dateChange', item.value);
};
const handleChangePeriod = item => {
	console.log(item);
	emit('update:activePeriod', item.value);
	emit('periodChange', item.value);
};
</script>
<style lang="less" scoped>
.main-business-dropdown {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 16px;
}
</style>